import { render, staticRenderFns } from "./WorkshopType.vue?vue&type=template&id=5b59d7ac"
import script from "./WorkshopType.vue?vue&type=script&lang=js"
export * from "./WorkshopType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports